var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.on_click()}}},[_c('path',{attrs:{"d":"M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3Z","fill":_vm.fill_color,"fill-opacity":_vm.opacity}})])
}
var staticRenderFns = []

export { render, staticRenderFns }